<template>
  <div class="app-container">
    <div class="filter-container">
      <div class="flex flex-ac flex-wrap">
        <el-input
          v-model="listQuery.order_number"
          placeholder="请输入订单号"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          v-model="listQuery.uuid"
          placeholder="请输入UUID"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          v-model="listQuery.username"
          placeholder="请输入用户名称"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          v-model="listQuery.user_id"
          placeholder="请输入会员ID"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <div>
          <div class="px-10 filter-item">订单时间</div>
          <el-date-picker
            class="filter-item"
            v-model="listQuery.date"
            @change="changedata"
            type="daterange"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="px-10 filter-item">订单状态</div>
        <el-select
          v-model="listQuery.financial_status_str"
          placeholder="状态"
          clearable
          multiple
          style="width: 200px"
          class="filter-item"
        >
          <el-option
            :label="item.name"
            :value="item.key"
            v-for="(item, index) in financialStatusList"
            :key="index"
          />
        </el-select>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
          >搜索</el-button
        >
      </div>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="会员ID" width="120">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="UUID" width="120">
        <template slot-scope="scope">
          {{ scope.row.uuid }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户名称" width="120">
        <template slot-scope="scope">
          {{ scope.row.username || '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="订单编号" width="220">
        <template slot-scope="scope">
          {{ scope.row.number }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="订单状态" width="120">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.financial_status === 'refunded'"
            type="danger"
            >{{ scope.row.financial_status_show }}</el-tag
          >
          <el-tag v-else-if="scope.row.financial_status === 'paid'"
            >{{ scope.row.financial_status_show }}
          </el-tag>
          <el-tag
            v-else-if="scope.row.financial_status === 'partially_refunded'"
            type="warning"
            >{{ scope.row.financial_status_show }}
          </el-tag>
          <el-tag
            v-else-if="scope.row.financial_status === 'waiting'"
            type="success"
            >{{ scope.row.financial_status_show }}
          </el-tag>
          <el-tag v-else type="warning"
            >{{ scope.row.financial_status_show }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="订单时间" width="220">
        <template slot-scope="scope">
          {{ scope.row.order_created_at }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="总金额" width="120">
        <template slot-scope="scope">
          {{ scope.row.total_price }}
        </template>
      </el-table-column>
      <el-table-column label="顾客姓氏" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.shipping_address.first_name ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="顾客名称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.shipping_address.last_name ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="顾客电话" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.shipping_address.phone ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="收件地址" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.shipping_address.address1 ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="商品总价" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.sub_total ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="订单商品折扣" min-width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_discount_amount ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="订单已退款总额" min-width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.finished_refund_price ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="营业额" min-width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.salas ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="实际统计销售额" min-width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_show_salas ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="实际营业额" min-width="130" align="center">
        <template slot-scope="scope">
          <el-input
            type="number"
            v-model="scope.row.actual_salas"
            size="small"
            @blur="updateActualSalas(scope.row)"
            @keyup.enter.native="updateActualSalas(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="实付总价" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_price ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="商城退款价格" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_refund_price ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="已处理退款价格" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.handle_total_refund_price ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="syncUpdateRefund(scope.row)"
          >
            同步更新退款
          </el-button>
          <el-button size="mini" type="primary" @click="toinfo(scope.row)">
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      financialStatusList: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        order_number: '',
        financial_status_str: [],
      },
    }
  },
  created() {
    this.getfinancialStatusList()
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  methods: {
    updateActualSalas(row) {
      if (row.actual_salas === '' || row.actual_salas === null) {
        return
      }
      if (row.actual_salas === row.original_actual_salas) {
        return
      }
      this.$confirm(
        '是否确认将订单' +
          row.number +
          '修改实际营业额为 ' +
          row.actual_salas +
          '？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          request({
            url: '/api/backend/order/updateActualSalas',
            method: 'post',
            data: {
              order_id: row.id,
              actual_salas: Number(row.actual_salas),
              remark: '',
            },
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          row.actual_salas = row.original_actual_salas
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    changedata(val) {
      console.log(val)
      if (val) {
        this.listQuery.start_at = val[0] + ' 00:00:00'
        this.listQuery.end_at = val[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    toinfo(row) {
      this.$router.push({
        path: '/order/orderdetila?order_number=' + row.number,
      })
    },
    syncUpdateRefund(row) {
      this.$confirm('是否确认同步更新退款？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/order/syncUpdateRefund',
            method: 'post',
            data: {
              order_number: row.number,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    getfinancialStatusList() {
      request({
        url: '/api/backend/order/financialStatusList',
        method: 'get',
      }).then((response) => {
        this.financialStatusList = response.data
      })
    },
    store(row) {
      this.$confirm('是否确认修改类型？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/product/store',
            method: 'post',
            data: {
              id: row.id,
              product_type:
                row.product_type == 'ordinary_retail'
                  ? 'vip_group'
                  : 'ordinary_retail',
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/order/list',
        method: 'get',
        params: {
          ...this.listQuery,
          financial_status_str: this.listQuery.financial_status_str.join(','),
        },
      }).then((response) => {
        this.list =
          response.data.data.map((item) => {
            return {
              ...item,
              actual_salas: item.actual_salas_overridden
                ? item.actual_salas
                : item.total_show_salas,
              original_actual_salas: item.actual_salas_overridden
                ? item.actual_salas
                : item.total_show_salas,
            }
          }) || []
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(val) {
      this.$router.push('/member/editmemberinfo')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.img {
  width: 150px;
  height: 150px;
  object-fit: contain;
}
</style>
